export default __webpack_public_path__ + "static/media/76.54442934.jpg";